import React, { useState } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

const ASPECT = 1071 / 170;
function ImageCropper(props) {
  const { imageToCrop, onImageCropped } = props;

  const [cropConfig, setCropConfig] = useState({
    unit: "%",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    aspect: ASPECT,
  });


  const [imageRef, setImageRef] = useState();

  const onImageLoaded = (img) => {
    setImageRef(img);
    
    const imageWidth = img.naturalWidth;
    const imageHeight = img.naturalHeight;

    let widthPercent = 100;
    let heightPercent = (100 / ASPECT) * (imageWidth / imageHeight);

    if (heightPercent > 100) {
      heightPercent = 100;
      widthPercent = 100 * ASPECT * (imageHeight / imageWidth);
    }

    const x = (100 - widthPercent) / 2;
    const y = (100 - heightPercent) / 2;

    setCropConfig({
      unit: "%",
      x,
      y,
      width: widthPercent,
      height: heightPercent,
      aspect: ASPECT,
    });

    return false;
  };

  async function cropImage(crop) {
    if (imageRef && crop.width && crop.height) {
      const croppedImage = await getCroppedImage(
        imageRef,
        crop,
        "croppedImage.jpeg"
      );

      onImageCropped(croppedImage);
    }
  }

  function getCroppedImage(sourceImage, cropConfig, fileName) {
    const canvas = document.createElement("canvas");
    
    canvas.width = 1071;
    canvas.height = 170;
    
    const ctx = canvas.getContext("2d");

    const naturalWidth = sourceImage.naturalWidth;
    const naturalHeight = sourceImage.naturalHeight;

    let cropX, cropY, cropWidth, cropHeight;

    if (cropConfig.unit === "%") {
      cropX = (cropConfig.x / 100) * naturalWidth;
      cropY = (cropConfig.y / 100) * naturalHeight;
      cropWidth = (cropConfig.width / 100) * naturalWidth;
      cropHeight = (cropConfig.height / 100) * naturalHeight;
    } else {
      const scaleX = naturalWidth / sourceImage.width;
      const scaleY = naturalHeight / sourceImage.height;
      
      cropX = cropConfig.x * scaleX;
      cropY = cropConfig.y * scaleY;
      cropWidth = cropConfig.width * scaleX;
      cropHeight = cropConfig.height * scaleY;
    }


    ctx.drawImage(
      sourceImage,
      cropX,
      cropY,
      cropWidth,
      cropHeight,
      0,
      0,
      1071,
      170
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error("Canvas is empty"));
          return;
        }

        blob.name = fileName;
        const croppedImageUrl = window.URL.createObjectURL(blob);

        resolve([croppedImageUrl, blob]);
      }, "image/jpeg", 0.95);
    });
  }

  return (
    <div className="react-crop-wrapper">
      <ReactCrop
        src={imageToCrop}
        crop={cropConfig}
        ruleOfThirds
        onImageLoaded={onImageLoaded}
        onComplete={(cropConfig) => cropImage(cropConfig)}
        onChange={(cropConfig) => setCropConfig(cropConfig)}
        crossorigin="anonymous"
        aspect={1071 / 170}
        keepSelection={true}
      />
    </div>
  );
}

ImageCropper.defaultProps = {
  onImageCropped: () => {},
};

export default ImageCropper;
